/**
 * インタビューページ用エントリースクリプト
 *
 * - .js-interview-slider要素が存在する場合のみスライダーを初期化
 * - スライダーの初期表示位置やナビゲーションをdata属性・オプションで制御
 *
 * @example
 *   import Interview from './pages/interview.js';
 *   Interview();
 *
 * 注意:
 * - .js-interview-slider要素とSwiper.js本体が必要
 * - data-interview-active属性で初期スライド指定
 */
import { Slider } from '../modules/slider.js';

export default function Interview() {
	// インタビュースライダーの初期化（要素が存在する場合のみ）
	window.addEventListener('load', () => {
		if (!document.querySelector('.js-interview-slider')) return;
		const active =
			Number(
				document.querySelector('.js-interview-slider').dataset.interviewActive
			) - 1;
		const options = {
			slidesPerView: 3,
			spaceBetween: 30,
			centeredSlides: true,
			loop: true,
			initialSlide: active,
			navigation: {
				nextEl: '.js-interview-slider .swiper-button-next',
				prevEl: '.js-interview-slider .swiper-button-prev',
			},
		};
		new Slider('.js-interview-slider', options);
	});
}
